import 'angular';
import 'jquery';
import 'bootstrap';
import $ from 'jquery';
import _ from 'lodash';
import moment from 'moment';
import 'fuse.js';
import Fuse from 'fuse.js';
import 'angular-i18n/angular-locale_nl-nl.js';
import XLSX from 'js-xlsx';
import 'sweetalert';
import * as Sentry from '@sentry/browser';
// import { Angular as AngularIntegration } from "@sentry/integrations";

window.$ = $;
window.jquery = window.$;
window.jQuery = window.$;
global.jQuery = $;
global.$ = $;
window._ = _;
window.Fuse = Fuse;
global.Fuse = Fuse;
global.XLSX = XLSX;
window.XLSX =  XLSX;
window.moment = moment;

global.$ = global.jQuery = require('jquery');
$.fn.datetimepicker = require('bootstrap-datepicker');

// require('imports-loader?this=>window!../pages/plugins/modernizr.custom');
// require('imports-loader?this=>window!../pages/plugins/modernizr.custom');
// import('../pages/plugins/modernizr.custom');
import '../pages/plugins/classie/classie';
import '../pages/plugins/jquery-autonumeric/autoNumeric.js';
import  '../pages/js/pages.min';




Sentry.init({
  dsn: "https://6684dd8809ac4f8295be936350f4aede@sentry.io/189751",
  // integrations: [new AngularIntegration()],
});

